import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import MovementCRUD from './Movement';

const Expense = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de Movimientos' pageTitle='Movimientos' />
                <MovementCRUD />
            </div>
        </React.Fragment>
    )
}

export default Expense;